import React from "react";
import { Box, Text, Tooltip, TooltipProps } from "@chakra-ui/react";
import SVG from "react-inlinesvg";
import CustomIcon from "../../../public/icons-v1_1";

interface Props extends Omit<TooltipProps, "children"> {
  text?: React.ReactNode;
  iconsSize?: number;
  color?: string;
  hasArrow?: boolean;
}

export default function HelpTooltip({
  text,
  iconsSize = 16,
  color = "#8F8F8C",
  placement = "top",
  hasArrow = true,
  ...props
}: Props) {
  return (
    <Tooltip label={text} placement={placement} hasArrow={hasArrow} {...props}>
      <Box>
        <CustomIcon
          src={"info-circle"}
          width={iconsSize}
          height={iconsSize}
          color={color}
        />
      </Box>
    </Tooltip>
  );
}
